import { render } from "./FranchiseCodesPage.vue?vue&type=template&id=63f98922&scoped=true"
import script from "./FranchiseCodesPage.vue?vue&type=script&lang=js"
export * from "./FranchiseCodesPage.vue?vue&type=script&lang=js"

import "./FranchiseCodesPage.vue?vue&type=style&index=0&id=63f98922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f98922"]])

export default __exports__